<template>
  <div class="full-screen" style="z-index: 10;">
    <!-- <div class="header-nav">
      <div class="left">
        <a class="lk-back" @click="returnPage()">返回</a>
      </div>
    </div> -->
    <div class="topbar flex">
      <div class="fl">
        <a @click="returnPage">
          <i class="fa-angle-left"></i>
        </a>
      </div>
      <div class="span-title">绑定手机</div>
      <a class="lk-home" @click="returnHome">
        <i class="fa-home"></i>
      </a>
    </div>


    <div class="login">
      <p style="text-align: center"><strong style="color:red;font-size: 1rem;text-align: center">重要提醒</strong></p>
      <P style="font-size: 0.8rem; color: #333; margin-top: 0.3rem">
        1.成功绑定手机后，<storng style="color: red">您可以通过输入手机号、密码登录您的账号</storng>;
      </P>
      <p style="font-size: 0.8rem; color: #333 ; margin-top: 0.3rem; margin-bottom: 0.8rem">
        2.为了保障您的账号安全与便捷性，<storng style="color:red">付费后请务必绑定手机号码</storng>!
      </p>
      <ul>
        <li>
          <label>手机号码</label>
          <div><input v-model="mobile" class="inp" type="text" placeholder="请输入绑定手机号"/></div>
        </li>
      </ul>

      <!-- 下面是错误提示 -->
      <div v-if="errorMsg.show" class="text-red">{{errorMsg.msg}}</div>
      <div class="btnbox">
        <button type="button" class="btn" @click="validate">绑定</button>
      </div>
    </div>

    <div id="confirm-modal" v-if="showModal" class="fixed-confirm" style="display: block;">
      <div class="fixed-c">
        <h3 style="text-align: center">{{changed ? '手机绑定成功' : resMsg}}</h3>
        <div class="btnbox">
          <button class="btn" type="button" @click="hideModal">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import userService from "../../../services/userService";

  export default {
    name: "mobile-bind",
    data() {
      return {
        mobile: '',
        pwd: '',
        confirmPwd: '',
        errorMsg: {
          show: false,
          msg: ''
        },
        changed: false,
        showModal: false,
        resMsg: ''
      }
    },
    methods: {
      returnPage() {
        this.$router.isBack = true;
        this.$router.go(-1);
      },
      returnHome() {
        this.$router.isBack = false;
        this.$router.push('/home');
      },
      validate() {
        let reg = /^1[0-9]{10}$/;
        if (this.mobile === '') {
          this.errorMsg = {show: true, msg: '请输入手机号'}
        } else if (!reg.test(this.mobile)) {
          this.errorMsg = {show: true, msg: '请输入正确的手机号'}
        }else {
          this.errorMsg = {show: false, msg: ''}
          this.bindMobile();
        }
      },
      bindMobile() {
        userService.bindMobile(this.mobile)
          .then(res => {
            if (res.result) {
              userService.updateUserInfo();
              this.changed = true;
              this.showModal = true;
            } else {
              this.changed = false;
              this.showModal = true;
              this.resMsg = res.msg
            }
          })
      },
      hideModal() {
        let obj = document.getElementById('confirm-modal');
        obj.style.opacity = 1;
        this.slideOut(obj);
      },
      slideOut(obj) {
        obj.style.opacity -= 0.05;
        if (obj.style.opacity > 0) {
          setTimeout(() => {
            this.slideOut(obj)
          }, 15)
        } else {
          this.showModal = false;
          this.$router.isBack = true;
          this.$router.go(-1);
        }
      }
    },
    mounted() {
      this.$router.isBack = true;
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/layer2/user/mobile-bind.vue